import { render, staticRenderFns } from "./modules.vue?vue&type=template&id=b23896e0"
import script from "./modules.vue?vue&type=script&lang=js"
export * from "./modules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports